{
    "rapormusterigecici": {
        "Baslik": "Customer Temporary Authority Report",
        "Kullanici": "User",
        "KullaniciGecici": "Temporary User",
        "AdSoyad": "Full Name",
        "Cep": "Mobile",
        "Referans": "Reference",
        "ID": "ID",
        "Takim": "Team",
        "Sube": "Branch",
        "Ara": "Search",
        "Temizle": "Clear",
        "Filtrele": "Filter",
        "Sil": "Delete",
        "Sayfada": "On Page",
        "Olusturma": "Creation",
        "Islem": "Action",
        "R": "R",
        "S": "S",
        "O": "P",
        "I": "C",
        "C": "W",
        "R_Tooltip": "Appointment Count",
        "S_Tooltip": "Approved Sales",
        "O_Tooltip": "Pending Sales",
        "I_Tooltip": "Cancelled Sales",
        "C_Tooltip": "Withdrawn Sales",
        "SilmeOnayMesaj": "Are you sure you want to remove this temporary authority?",
        "SilmeBasarisiz": "Deletion failed",
        "YetkinizYok": "You do not have permission.",
        "YetkiKaldirildi": "Temporary authority removed.",
        "Kapat": "Close"
    }
}
